module.exports = {
      id: "sprite-placeholder-usage",
      viewBox: "0 0 273.4 222.2",
      url: __webpack_public_path__ + "svgs/sprite-2389f1.svg#sprite-placeholder",
      toString: function () {
        return this.url;
      }
    }